import React from "react";
import { Box, Fade, Grid, styled, Typography, useTheme } from "@mui/material";
import { CenteredSiteBlock } from "../../routes/Home";
import SpecialCard from "../card/SpecialCard";
import { useIsMobile } from "../../hooks/responsive";
import useIsOnScreen from "../../hooks/useIsOnScreen";

const Container = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    minHeight: "100px",
    background:
      "linear-gradient(103.53deg, #0596A1 1.52%, #3971F6 20.93%, #9A45F4 43.18%, #FC7D06 62.12%, #F7E144 81.06%, #FF4626 100%)",
  };
});

const cardContents = [
  "Fédérer un réseau solidaire de praticiens engagés dans une approche holistique et éthique du mieux-être, en valorisant la conscience professionnelle, la responsabilité et l'entraide.",
  "Construire un écosystème dédié à la formation continue, au partage d’expériences et à l’alignement entre posture intérieure et cadre professionnel.",
  "Relier les savoirs anciens aux connaissances émergentes, mêlant science, traditions et pratiques transversales, avec exigence et discernement.",
  "Explorer l'invisible, l'extraordinaire et les états modifiés de conscience, dans une recherche d'intégration et de bénéfices concrets au quotidien. ",
];

const GradientTypo = styled(Typography)(({
  theme,
  disabled = false,
  fontSize = "40px",
  background,
  // Adjusted borderWidth to a smaller, fractional value
  borderWidth = "1px",
  borderColor = "#FFFFFF",
}) => {
  return {
    background:
      disabled === false
        ? background
          ? background
          : "linear-gradient(90deg, #EE7992 0%, #F1AE65 50.51%, #F4C54D 100%)"
        : theme.palette.grey["400"],
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    overflow: "hidden",
    fontFamily: "Branding Semibold",
    fontSize: fontSize,
    fontWeight: 400,
    display: "inline-block",
    WebkitTextStrokeWidth: borderWidth,
    WebkitTextStrokeColor: "white",
  };
});

const AmbitionCard = ({ index, text, ...props }) => {
  const theme = useTheme();

  const ref = React.useRef(null);
  const isVisible = useIsOnScreen(ref);

  return (
    <Box
      ref={ref}
      sx={{
        display: "flex",
        position: "relative",
        marginTop: 18,
        zIndex: 1,
      }}
    >
      <Fade in={isVisible} timeout={index * 500}>
        <Box>
          <GradientTypo
            background={
              "linear-gradient(180deg, rgba(255, 255, 255, 0.1482) 25.77%, rgba(255, 255, 255, 0.0546) 95.73%)"
            }
            sx={{
              zIndex: -1,
              position: "absolute",
              top: "-120px",
              left: "-20px",
              fontSize: "200px",
              lineHeight: "100%",
              letterSpacing: 0,
              fontFamily: "Branding Bold",
              color:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.1482) 25.77%, rgba(255, 255, 255, 0.0546) 95.73%)",
            }}
          >
            {index}
          </GradientTypo>
          <SpecialCard sx={{ padding: 4 }}>
            <Typography
              aria-multiline={true}
              sx={{
                textWrap: "wrap",
                width: "100%",
                maxWidth: "100%",
                fontFamily: "Branding Semibold",
                fontWeight: 600,
              }}
            >
              {text}
            </Typography>
          </SpecialCard>
        </Box>
      </Fade>
    </Box>
  );
};

const Ambitions = () => {
  const isMobile = useIsMobile();

  return (
    <Container className={"ambitions"}>
      <CenteredSiteBlock>
        <Box
          sx={{
            mt: 6,
            mb: 6,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginRight: { xs: "10vw", sm: "5vw", lg: "5vw", xl: 0 },
            marginLeft: { xs: "10vw", sm: "5vw", lg: "5vw", xl: 0 },
          }}
        >
          <Typography
            variant="h3"
            sx={{
              color: "white",
              fontFamily: "Branding Bold",
              fontSize: "28px",
              zIndex: 1,
              textAlign: "center",
            }}
          >
            Les 4 ambitions d'Inexploré Praticiens
          </Typography>
          <Grid container spacing={isMobile ? 0 : 5}>
            {cardContents.map((content, index) => (
              <Grid
                item
                size={{ xs: 12, sm: 6, lg: 3 }}
                key={"ambitionCard-" + index}
              >
                <AmbitionCard index={index + 1} text={cardContents[index]} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </CenteredSiteBlock>
    </Container>
  );
};

export default Ambitions;
